import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import eventTypes from '../../../../enums/Event.enums';
import Icon from '../../../@shared/icon';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import { TNavigationBarDropdownDesktopProps } from '../types/navigationBar.types';

const NavigationBarDropdownDesktop: FC<TNavigationBarDropdownDesktopProps> = (props) => {
  const {
    handleClick,
    title,
    dropDownSeriesData,
    dropdownIsOpen,
    contextItemUrl,
    isUnderSuperSerie,
    handleCloseDropdown,
    formTitleUrl,
    clickPageNavEvent,
  } = props;

  const hasDropDownSeriesData = dropDownSeriesData && dropDownSeriesData?.length > 1;

  return (
    <div className={`navigation-bar__dropdown ${hasDropDownSeriesData ? 'navigation-bar__dropdown--pointer' : ''}`}>
      <span className="navigation-bar__dropdown-content"
       role="button"
       onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleClick();
         }
       }>
        <span className="navigation-bar__dropdown-data" title={title}>
          {title}
        </span>
        {hasDropDownSeriesData && (
          <Icon
            iconName={dropdownIsOpen ? 'arrow-chevron-up' : 'arrow-chevron-down'}
            size={iconSize.dsk}
            color="white"
            extraClassName={`navigation-bar__dropdown-icon ${dropdownIsOpen ? 'navigation-bar__dropdown-icon--is-open' : ''}`}
          />
        )}
      </span>
      {dropdownIsOpen && (
        <ul className="navigation-bar__dropdown-list">
          {dropDownSeriesData?.map((dropDownData, index) => {
            const redirectUrl = formTitleUrl(contextItemUrl || '', dropDownData?.titleUrl || '', !!isUnderSuperSerie);
            return dropDownData.title !== null && dropDownData.title !== '' ? (
              <li className="navigation-bar__dropdown-list-item" key={index} onClick={handleCloseDropdown}>
                <RoutableNotEditableLink
                  href={redirectUrl}
                  className="navigation-bar__dropdown--contents--link"
                  onClick={() => clickPageNavEvent(eventTypes.navEvent, dropDownData?.title, index + 1)}
                >
                  {dropDownData?.title}
                </RoutableNotEditableLink>
              </li>
            ) : null;
          })}
        </ul>
      )}
    </div>
  );
};

export default NavigationBarDropdownDesktop;
